var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-pagination-controls body-md" }, [
    _vm.pages !== 1
      ? _c(
          "div",
          { staticClass: "search-pagination-controls-icons" },
          [
            _vm.currentPage === 1
              ? _c("icon", {
                  staticClass: "search-pagination-controls__disabled-prev",
                  attrs: { name: "arrow-right", size: "24px" }
                })
              : _vm._e(),
            _vm.currentPage !== 1
              ? _c("icon", {
                  staticClass: "search-pagination-controls__arrow-prev",
                  attrs: { name: "arrow-right", size: "24px" },
                  on: { click: _vm.prevPage }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "search-pagination-controls__pages",
        on: { click: _vm.toggleNav }
      },
      [
        _vm._v("Page " + _vm._s(_vm.currentPage) + " of " + _vm._s(_vm.pages)),
        _vm.pages > 1
          ? _c("icon", {
              staticClass: "search-pagination-controls__page-nav-caret",
              class: { flipped: _vm.pageNavActive },
              attrs: { name: "caret-down", size: "8px" }
            })
          : _vm._e(),
        _c(
          "fade-transition",
          { attrs: { duration: { enter: 200, leave: 200 } } },
          [
            _vm.pageNavActive
              ? _c(
                  "div",
                  { staticClass: "search-pagination-controls__page-nav" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "search-pagination-controls__page-nav-inner"
                      },
                      _vm._l(_vm.pages, function(page, index) {
                        return _c(
                          "div",
                          {
                            staticClass:
                              "search-pagination-controls__page-nav-button",
                            on: {
                              click: function($event) {
                                return _vm.goToPage(page)
                              }
                            }
                          },
                          [
                            page === _vm.currentPage
                              ? _c(
                                  "span",
                                  { staticClass: "current-page" },
                                  [
                                    _vm._v("page " + _vm._s(page)),
                                    _c("icon", {
                                      attrs: {
                                        name: "checkmark_small",
                                        size: "10px"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _c("span", [_vm._v("page " + _vm._s(page))])
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      ],
      1
    ),
    _vm.pages !== 1
      ? _c(
          "div",
          { staticClass: "search-pagination-controls-icons" },
          [
            _vm.currentPage !== _vm.pages
              ? _c("icon", {
                  staticClass: "search-pagination-controls__arrow-next",
                  attrs: { name: "arrow-right", size: "24px" },
                  on: { click: _vm.nextPage }
                })
              : _vm._e(),
            _vm.currentPage === _vm.pages
              ? _c("icon", {
                  staticClass: "search-pagination-controls__disabled-next",
                  attrs: { name: "arrow-right", size: "24px" }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }